var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "upload icon"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46950",
    d: "M19.091 10.909a.909.909 0 0 0-.909.909v3.83a2.536 2.536 0 0 1-2.534 2.534H4.352a2.536 2.536 0 0 1-2.534-2.534v-3.83a.909.909 0 1 0-1.818 0v3.83A4.356 4.356 0 0 0 4.352 20h11.3A4.356 4.356 0 0 0 20 15.648v-3.83a.909.909 0 0 0-.909-.909z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46951",
    d: "m5.188 7.006 3.9-3.9v11.439a.909.909 0 0 0 1.818 0V3.1l3.9 3.9a.91.91 0 1 0 1.286-1.286L10.642.266a.909.909 0 0 0-1.285 0L3.902 5.721a.909.909 0 1 0 1.286 1.285z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save-icon.40cae5ee80e207d764c6490bf7e78548.svg";
export { ForwardRef as ReactComponent };